import React, { useState } from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Search, FeaturePlaceholder, Table, Badge } from '@/components/ui';
import { useAuth } from '@/core/auth/AuthContext';
import { useWorkloadRules } from './hooks/useMaintenanceWorkload';

export default function WorkloadRulesPage() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const [search, setSearch] = useState('');

  const { data: rules = [], isLoading } = useWorkloadRules(companyId);

  return (
    <PageLayout
      title="Định mức Workload"
      description="Cấu hình định mức giờ công cơ sở cho từng loại tài sản và công việc bảo dưỡng."
      breadcrumbs={[{ label: 'Workload', path: '/maintenance/workload' }, { label: 'Định mức' }]}
      isLoading={isLoading}
      headerActions={
        <Button variant="primary" icon="ri-add-line">Thêm định mức</Button>
      }
    >
      <div className="space-y-6">
        <PageLayout.Toolbar>
          <Search
            placeholder="Tìm theo loại tài sản, công việc..."
            value={search}
            onChange={setSearch}
            className="w-80"
          />
        </PageLayout.Toolbar>

        <Card className="overflow-hidden border-none shadow-sm">
          <Table
            columns={[
              { key: 'asset_type', title: 'Loại tài sản' },
              { key: 'task_type', title: 'Loại công việc' },
              { key: 'base_hours', title: 'Giờ công cơ sở', align: 'right' },
              { key: 'default_difficulty', title: 'Độ khó mặc định', align: 'center' },
              { key: 'description', title: 'Mô tả' },
              { key: 'actions', title: '', align: 'right' },
            ]}
            data={rules.filter(r =>
              r.asset_type.includes(search.toLowerCase()) ||
              r.task_type.includes(search.toLowerCase())
            )}
            isLoading={isLoading}
            renderCell={(item, key) => {
              switch (key) {
                case 'asset_type':
                  return <span className="font-bold text-slate-900  text-xs">{item.asset_type}</span>;
                case 'task_type':
                  return <span className="text-slate-600 capitalize">{item.task_type}</span>;
                case 'base_hours':
                  return <span className="font-bold text-os-primary">{item.base_man_hours_per_unit}h / đơn vị</span>;
                case 'default_difficulty':
                  return <Badge variant="custom">{item.default_difficulty}x</Badge>;
                case 'description':
                  return <span className="text-xs text-slate-500">{item.description}</span>;
                case 'actions':
                  return (
                    <div className="flex justify-end gap-1">
                      <Button variant="ghost" size="sm" icon="ri-edit-line" />
                      <Button variant="ghost" size="sm" icon="ri-delete-bin-line" className="text-red-400" />
                    </div>
                  );
                default:
                  return null;
              }
            }}
          />

          {rules.length === 0 && !isLoading && (
            <div className="py-20">
              <FeaturePlaceholder
                title="Định mức bảo dưỡng"
                description="Thiết lập các chỉ số giờ công tiêu chuẩn giúp hệ thống tự động tính toán khối lượng chính xác cho hàng nghìn tài sản."
              />
            </div>
          )}
        </Card>
      </div>
    </PageLayout>
  );
}
